import { ModalDatailFlower } from '@lideralia/alife-uikit/dist/organisms/Modals/DatailFlower';
import React from 'react';

export const ProductDetailTemplate = (props) => <ModalDatailFlower {...props} />;
